// Single frontend home for unit display labels. Handles BOTH vocabularies that
// reach the UI so no surface ever echoes a raw code (Polish-first rule):
//   - lowercase sale-unit / WZ codes ('pcs', 'm2', ...) — mirrors backend
//     unitLabels.js (the document-side source of truth)
//   - the uppercase `ProductUnit` enum ('PIECE', 'SQUARE_METER', ...) stored as
//     a product's baseUnit and carried onto PZ lines.
import { normalizeLanguageCode } from './numberFormatting';

const PL_UNIT_LABELS: Record<string, string> = {
  // lowercase sale-unit / WZ line codes
  pcs: 'szt.',
  m2: 'm²',
  m3: 'm³',
  kg: 'kg',
  mb: 'mb',
  m: 'm',
  l: 'l',
  // ProductUnit enum (uppercase) — product baseUnit, e.g. on PZ item lines
  PIECE: 'szt.',
  KILOGRAM: 'kg',
  METER: 'm',
  LINEAR_METER: 'mb',
  SQUARE_METER: 'm²',
  CUBIC_METER: 'm³',
  LITER: 'l',
  SET: 'kpl.',
  PACKAGE: 'opak.',
};

const EN_UNIT_LABELS: Record<string, string> = {
  ...PL_UNIT_LABELS,
  pcs: 'pcs',
  PIECE: 'pcs',
  mb: 'lm',
  LINEAR_METER: 'lm',
  SET: 'set',
  PACKAGE: 'pkg',
};

export function formatUnit(
  unit: string | null | undefined,
  language = 'pl',
): string {
  const labels = normalizeLanguageCode(language) === 'en' ? EN_UNIT_LABELS : PL_UNIT_LABELS;
  if (!unit) return labels.pcs;
  return labels[unit] || unit;
}
